import { useEffect, useState } from "react";

const TERMS_VERSION = "v1";

export default function TermsPopup() {
  const [isOpen, setIsOpen] = useState(false);
  const [isChecked, setIsChecked] = useState(false);

  useEffect(() => {
    const acceptedVersion = localStorage.getItem("termsAcceptedVersion");

    if (acceptedVersion !== TERMS_VERSION) {
      setIsOpen(true);
      document.body.style.overflow = "hidden";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  function handleAgree() {
    localStorage.setItem("termsAcceptedVersion", TERMS_VERSION);
    setIsOpen(false);
    document.body.style.overflow = "";
  }

  if (!isOpen) return null;

  return (
    <div className="terms-overlay">
      <div className="terms-modal">
        <h1>Terms of Use</h1>

        <div className="terms-content">

<p>
Welcome to Hopeful Horizons NY LLC. By accessing, browsing, using, viewing, interacting with, submitting information through, creating a profile on, communicating through, downloading materials from, uploading materials to, or otherwise utilizing this website, platform, directory, resource hub, informational tool, or related services (collectively referred to as the “Platform”), you acknowledge, affirm, represent, and agree that you have carefully reviewed, fully understood, and voluntarily accepted all terms, conditions, notices, limitations, disclaimers, responsibilities, and obligations set forth herein, whether or not you have actually read each provision in its entirety.
</p>

<p>
Hopeful Horizons NY LLC provides a centralized informational directory and resource platform designed to assist individuals, families, care managers, self-directed participants, fiscal intermediaries, professionals, and community members in identifying potential Direct Support Professionals (DSPs), service providers, organizations, activities, resources, and other informational listings that may be relevant to services associated with Self-Direction, Community Habilitation, Respite, and related supports. The Platform is provided solely for informational, organizational, and convenience purposes and does not constitute, imply, or create any employment relationship, agency relationship, partnership, joint venture, supervisory arrangement, referral guarantee, endorsement, certification, or formal approval of any individual, provider, listing, service, or organization.
</p>

<p>
Hopeful Horizons NY LLC does not employ, engage, contract with, supervise, evaluate, manage, monitor, oversee, control, or direct any provider, DSP, organization, or service listed, referenced, linked, displayed, or otherwise made available through the Platform. All providers operate independently and are solely responsible for their own conduct, qualifications, services, communications, compliance, actions, omissions, and professional responsibilities. Inclusion on the Platform does not constitute endorsement, verification, recommendation, approval, or validation of any provider’s qualifications, competencies, experience, availability, reliability, character, or compliance with any applicable regulatory or legal standards.
</p>

<p>
Hopeful Horizons NY LLC does not conduct, perform, guarantee, or represent that it conducts any background checks, credential verification, license verification, certification confirmation, identity validation, insurance verification, eligibility screening, criminal history review, employment verification, training verification, skills validation, suitability assessment, or professional competency evaluation for any provider listed on the Platform, unless explicitly and clearly stated otherwise in writing. Users of the Platform are solely and exclusively responsible for independently verifying all relevant information, including but not limited to credentials, references, qualifications, certifications, experience, training, insurance coverage, eligibility requirements, background clearances, and compliance with OPWDD, Medicaid, Self-Direction, Fiscal Intermediary (FI), Care Manager, or other regulatory requirements prior to hiring, engaging, communicating with, or otherwise interacting with any provider.
</p>

<p>
Hopeful Horizons NY LLC makes no representations, warranties, guarantees, assurances, promises, or claims regarding the accuracy, completeness, reliability, availability, timeliness, safety, quality, legality, appropriateness, suitability, professionalism, qualifications, responsiveness, communication, performance, outcomes, or compatibility of any provider, listing, activity, service, document, guide, template, resource, link, or information contained within or accessible through the Platform. All decisions made by users, including but not limited to contacting providers, hiring providers, engaging services, scheduling services, communicating with providers, participating in activities, or relying on any information presented through the Platform, are made entirely at the user’s own discretion, judgment, responsibility, and risk.
</p>

<p>
Hopeful Horizons NY LLC shall not be held responsible or liable, whether directly or indirectly, for any damages, losses, claims, disputes, delays, interruptions, misunderstandings, miscommunications, injuries, incidents, dissatisfaction, service issues, provider conduct concerns, financial losses, billing disputes, scheduling conflicts, regulatory concerns, eligibility issues, documentation issues, reimbursement issues, compliance issues, property damage, personal injury, emotional distress, dissatisfaction with services, lack of services, delays in services, or any other consequences, whether foreseeable or unforeseeable, arising from or related to use of the Platform or interactions between users and any provider, organization, activity, or resource referenced on the Platform.
</p>

<p>
Users acknowledge and agree that Hopeful Horizons NY LLC is not a party to any agreement, arrangement, understanding, communication, contract, working relationship, or service engagement between users and providers. Any agreement or understanding entered into between users and providers exists solely between those parties, and Hopeful Horizons NY LLC bears no responsibility for any aspect of such relationships, including but not limited to communication expectations, performance expectations, service quality, documentation requirements, scheduling arrangements, compensation arrangements, reimbursement processes, tax considerations, insurance requirements, compliance obligations, or dispute resolution.
</p>

<p>
Any templates, documents, guides, informational materials, tools, references, examples, suggestions, or educational content made available through the Platform are provided solely for general informational purposes and may not reflect the most current regulatory requirements, legal standards, policy changes, or procedural expectations applicable to a user’s specific situation. Users assume full responsibility for evaluating the appropriateness, accuracy, and applicability of any such materials prior to relying upon them. Nothing contained on the Platform constitutes legal advice, medical advice, therapeutic advice, financial advice, tax advice, compliance advice, or professional consultation of any kind.
</p>

<p>
Hopeful Horizons NY LLC is not affiliated with, endorsed by, sponsored by, or formally connected to the New York State Office for People With Developmental Disabilities (OPWDD), any Fiscal Intermediary (FI), Care Management Organization (CMO), Managed Care Organization (MCO), government entity, regulatory body, licensing authority, or third-party organization unless explicitly stated. Users remain solely responsible for ensuring that all services, hires, documentation practices, reimbursements, and arrangements comply with all applicable federal, state, and local laws, regulations, OPWDD guidelines, Medicaid requirements, Self-Direction rules, FI requirements, and any other applicable compliance standards.
</p>

<p>
The Platform may contain references, links, integrations, or connections to third-party websites, tools, or services. Hopeful Horizons NY LLC does not control, monitor, evaluate, or assume responsibility for the content, accuracy, reliability, policies, practices, security, availability, or functionality of any third-party websites or services. Accessing third-party resources is done entirely at the user’s own discretion and risk.
</p>

<p>
Users acknowledge that the Platform may evolve, change, update, or modify features, functionality, availability, or content at any time without prior notice. Hopeful Horizons NY LLC reserves the right to modify, revise, update, or replace these Terms of Use at any time, and continued use of the Platform following any modifications constitutes acceptance of such changes.
</p>

<p>
By checking the acknowledgment box and continuing to use the Platform, users confirm that they have read, understood, and agreed to these Terms of Use in their entirety, accept full responsibility for their decisions and actions, and acknowledge that use of the Platform is voluntary and undertaken at their own risk.
</p>

        </div>

        <label className="terms-checkbox-row">
          <input
            type="checkbox"
            checked={isChecked}
            onChange={(e) => setIsChecked(e.target.checked)}
          />
          <span>
            By checking this box, I acknowledge that I have reviewed and agree to the Terms of Use.
          </span>
        </label>

        <div className="terms-actions">
          <button
            type="button"
            className="terms-button"
            disabled={!isChecked}
            onClick={handleAgree}
          >
            Agree & Continue
          </button>
        </div>

        {!isChecked && (
          <p className="terms-note">
            Please check the box above to continue.
          </p>
        )}

        <style>{`
          .terms-overlay {
            position: fixed;
            inset: 0;
            background: rgba(0, 0, 0, 0.55);
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 20px;
            z-index: 2000;
          }

          .terms-modal {
            background: white;
            width: 100%;
            max-width: 760px;
            border-radius: 18px;
            padding: 28px;
            box-shadow: 0 18px 50px rgba(0, 0, 0, 0.25);
          }

          .terms-modal h1 {
            margin-top: 0;
            margin-bottom: 16px;
            color: #2f6f89;
            text-align: center;
          }

          .terms-content {
            max-height: 380px;
            overflow-y: auto;
            border: 1px solid #dbe1ea;
            border-radius: 12px;
            padding: 18px;
            background: #fafcfe;
            text-align: left;
            line-height: 1.7;
          }

          .terms-content p {
            margin-top: 0;
            margin-bottom: 16px;
            color: #374151;
            font-size: 0.98rem;
          }

          .terms-checkbox-row {
            display: flex;
            align-items: flex-start;
            gap: 10px;
            margin-top: 18px;
            text-align: left;
            color: #374151;
            font-size: 0.96rem;
            line-height: 1.5;
          }

          .terms-actions {
            margin-top: 18px;
            display: flex;
            justify-content: center;
          }

          .terms-button {
            background: #2f6f89;
            color: white;
            border: none;
            padding: 12px 22px;
            border-radius: 10px;
            font-weight: 600;
            font-size: 1rem;
            cursor: pointer;
          }

          .terms-button:disabled {
            opacity: 0.45;
            cursor: not-allowed;
          }

          .terms-note {
            margin-top: 12px;
            text-align: center;
            color: #6b7280;
            font-size: 0.92rem;
          }
        `}</style>

      </div>
    </div>
  );
}